import { render, staticRenderFns } from "./VideoDisplayModal.vue?vue&type=template&id=4b53d3b9&scoped=true&"
import script from "./VideoDisplayModal.vue?vue&type=script&lang=js&"
export * from "./VideoDisplayModal.vue?vue&type=script&lang=js&"
import style0 from "./VideoDisplayModal.vue?vue&type=style&index=0&id=4b53d3b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53d3b9",
  null
  
)

export default component.exports